import React from 'react';

export default ({ color, width, height }) => (
  <svg id="Objects" width={width} height={height} viewBox="0 0 84.46 84.46">
    <path
      style={{ fill: color }}
      d="M30.66,21.93a.73.73,0,0,0-.3-.76l-2.05-1.51.08-2.5a.81.81,0,0,0-.38-.69.69.69,0,0,0-.83.08L25.13,18l-2.35-.83a.83.83,0,0,0-.76.15.76.76,0,0,0-.22.75l.75,2.43-1.51,2a.82.82,0,0,0-.08.83.72.72,0,0,0,.68.46h2.5l1.44,2a.7.7,0,0,0,.61.31h.08a.73.73,0,0,0,.6-.53l.76-2.43,2.42-.68A.65.65,0,0,0,30.66,21.93Zm-3.79-.08a.82.82,0,0,0-.53.46L26,23.67l-.75-1.14a.72.72,0,0,0-.61-.3H23.24l.83-1.06a.76.76,0,0,0,.15-.68l-.53-1.36,1.29.45a.68.68,0,0,0,.68-.08l1.14-.83L26.72,20a.71.71,0,0,0,.3.61l1.14.83Z"
    />
    <path
      style={{ fill: color }}
      d="M69.75,13.82a.68.68,0,0,0-.75-.23l-2.43.54-1.82-1.75a.74.74,0,0,0-.75-.15.64.64,0,0,0-.46.61l-.38,2.5L61,16.63a.79.79,0,0,0-.37.68A.86.86,0,0,0,61,18l2.27,1,.46,2.5a.85.85,0,0,0,.53.61h.23a.86.86,0,0,0,.6-.23L66.8,20l2.5.3a1,1,0,0,0,.76-.3.82.82,0,0,0,0-.83l-1.29-2.28,1.06-2.27A.71.71,0,0,0,69.75,13.82Zm-3.1,4.55a1,1,0,0,0-.69.23l-.9,1.06-.31-1.37a.78.78,0,0,0-.45-.53L63,17.23l1.21-.68a.77.77,0,0,0,.38-.61l.15-1.36,1,.91a.71.71,0,0,0,.68.15l1.36-.3-.6,1.21a1,1,0,0,0,0,.68l.68,1.21Z"
    />
    <circle style={{ fill: color }} cx="61.49" cy="40.79" r="0.91" />
    <circle style={{ fill: color }} cx="27.78" cy="31.32" r="0.91" />
    <circle style={{ fill: color }} cx="69.45" cy="26.32" r="0.91" />
    <circle style={{ fill: color }} cx="46.65" cy="24.58" r="0.91" />
    <path
      style={{ fill: color }}
      d="M66.57,54.88a3,3,0,1,0,3,3A3,3,0,0,0,66.57,54.88Zm0,4.4a1.44,1.44,0,0,1-1.44-1.44,1.44,1.44,0,0,1,2.88,0A1.44,1.44,0,0,1,66.57,59.28Z"
    />
    <path
      style={{ fill: color }}
      d="M43.77,12.23a3,3,0,1,0,2.95,3A3,3,0,0,0,43.77,12.23Zm0,4.4a1.44,1.44,0,0,1-1.44-1.44,1.44,1.44,0,1,1,2.88,0A1.45,1.45,0,0,1,43.77,16.63Z"
    />
    <path
      style={{ fill: color }}
      d="M57.86,23.82a3,3,0,1,0,3,3A3,3,0,0,0,57.86,23.82Zm0,4.47a1.43,1.43,0,0,1-1.44-1.44,1.44,1.44,0,1,1,2.88,0A1.44,1.44,0,0,1,57.86,28.29Z"
    />
    <path
      style={{ fill: color }}
      d="M34.83,30.79a1.07,1.07,0,0,0-.68-.22.79.79,0,0,0-.54.45L13.46,72.92a.7.7,0,0,0,.15.83.72.72,0,0,0,.53.23.45.45,0,0,0,.31-.08l42-20.15a.78.78,0,0,0,.45-.53.64.64,0,0,0-.22-.68Zm10.6,26.59L40,38.07l8.18,8.18,2.5,8.63ZM34.52,32.61l3.26,3.26,6.37,22.2-5,2.42L32.4,37.16ZM32.63,63.52,27.71,46.7l3.63-7.57,6.29,22Zm-6.52,3.11-3-10.38,3.64-7.5L31.27,64.2Zm-6.28,3-1.22-4,3.56-7.35,2.66,9Zm-2.2-2,.83,2.65-2.72,1.29ZM52,54.2l-1.66-5.76,4.39,4.4Z"
    />
    <path
      style={{ fill: color }}
      d="M45,33.82a.73.73,0,0,0,1.06,0c.3-.3,7.27-8.1,7-21.29a.76.76,0,0,0-1.52,0C51.8,25.11,45.05,32.69,45,32.76A.73.73,0,0,0,45,33.82Z"
    />
    <path
      style={{ fill: color }}
      d="M72.56,32.38c-13.11-2-21.07,7.81-21.22,8a.75.75,0,0,0,.15,1.06,1.24,1.24,0,0,0,.46.15.72.72,0,0,0,.61-.3c.07-.08,7.57-9.25,19.77-7.35a.71.71,0,0,0,.83-.61A.83.83,0,0,0,72.56,32.38Z"
    />
    <path
      style={{ fill: color }}
      d="M39.07,28.52h.15a.74.74,0,0,0,.76-.61c.07-.3,1.74-7.88-3.41-12.42a.74.74,0,0,0-1.06.07.75.75,0,0,0,.07,1.07c4.47,3.93,3,10.9,3,11A.82.82,0,0,0,39.07,28.52Z"
    />
    <path
      style={{ fill: color }}
      d="M57.63,45.94a.83.83,0,0,0-.53.91.82.82,0,0,0,.91.53c.08,0,8.56-2.57,12.27,2.66a.71.71,0,0,0,.61.3,1.14,1.14,0,0,0,.45-.15.73.73,0,0,0,.16-1.06C67.25,43.07,58,45.87,57.63,45.94Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/SHS_Icons__Success.js